module.exports = __webpack_public_path__ + "img/notice_popup.9365b1f1.png";